<template>
  <a :class="classes" :href="href" @click="onTap">
    <span class="dn-tabs__item-content"><slot /></span>
  </a>
</template>



<script>



export default {
  props: {
    href: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },



  computed: {
    classes() {
      return {
        'dn-tabs__item': true,
        'dn-tabs__item--active': this.isActive,
        'dn-tabs__item--disabled': this.disabled,
      }
    },
    action() { return this.href.replace(/^#/, '') },
    tabs() { return this.$parent.$parent },
    isActive() { return this.tabs.value === this.action },
  },



  watch: {
    disabled() {
      this.emitDisabled();
    },
  },



  methods: {
    emitDisabled() {
      this.tabs.onItemDisabledChange(this.action, this.disabled);
    },

    onTap(e) {
      e.preventDefault();
      if (this.disabled) return;
      this.tabs.set(this.action);
    },

    created() {
      this.emitDisabled();
    },
  },
}
</script>


// WEBPACK FOOTER //
// TabsItem.vue?074c1524